/**
 * The column layout shared by a product's feature header and every
 * `FeatureRow` under it.
 *
 * It lives in one place because a header and its rows drifting apart is the
 * whole failure mode of a hand-aligned table: the part numbers stop sitting
 * under "Part number" and the price column stops being a column. Both sides
 * read this one template.
 *
 * The name is `minmax(0, 1fr)` — 0, not `auto` — so a long feature name
 * ellipsizes inside its cell instead of pushing the priced columns off the
 * right edge.
 */
export const FEATURE_COLUMN_WIDTHS = {
  partNumber: "132px",
  category: "168px",
  price: "160px",
  /** Edit + delete, or nothing at all for a read-only viewer. */
  actions: "72px",
} as const;

export function featureGridTemplate(canEdit: boolean): string {
  const { partNumber, category, price, actions } = FEATURE_COLUMN_WIDTHS;
  return [
    "minmax(0, 1fr)",
    partNumber,
    category,
    price,
    ...(canEdit ? [actions] : []),
  ].join(" ");
}
